export enum PostFormAllowAttachments {
    Disallowed,
    Optional,
    Required
}

export namespace PostFormAllowAttachments {

    export function allowValues(): PostFormAllowAttachments[] {
        return [
            PostFormAllowAttachments.Optional,
            PostFormAllowAttachments.Required
        ];
    }

    export function getLabel(allowAttachments: PostFormAllowAttachments): string {
        switch (allowAttachments) {
            case PostFormAllowAttachments.Disallowed:
                return '';
            case PostFormAllowAttachments.Optional:
                return 'Attachment is optional';
            case PostFormAllowAttachments.Required:
                return 'Attachment is required';
            default:
                return '';
        }
    }
}